/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { State, Props } from './State.types.tsx';

export const switchPreviewContributorMode =
	(isPreviewOn: boolean): Action<State, Props> =>
	({ setState }) => {
		setState({
			isPreviewContributorMode: isPreviewOn,
		});
	};
